var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgVideo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 53.333,
    height: 40,
    viewBox: "0 0 53.333 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "video_default",
    transform: "translate(-1.5 -1.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3826",
    "data-name": "Path 3826",
    d: "M45.136,5.136H11.2c-2.678,0-4.848,1.628-4.848,3.636V34.227c0,2.008,2.171,3.636,4.848,3.636H45.136c2.678,0,4.848-1.628,4.848-3.636V8.773C49.985,6.764,47.814,5.136,45.136,5.136ZM11.2,1.5c-5.355,0-9.7,3.256-9.7,7.273V34.227c0,4.017,4.341,7.273,9.7,7.273H45.136c5.355,0,9.7-3.256,9.7-7.273V8.773c0-4.017-4.341-7.273-9.7-7.273Z",
    fill: "#b1b1b1",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3827",
    "data-name": "Path 3827",
    d: "M24,18l-9,6.495V11.505Z",
    transform: "translate(10.5 3.995)",
    fill: "#b1b1b1"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideo);
export default __webpack_public_path__ + "static/media/video.c624a911c7ad0fdd0d260e56ec314529.svg";
export { ForwardRef as ReactComponent };